import { useState, useEffect } from 'react';
import NorthernLights from './NorthernLights';
import Snowflakes from './Snowflakes';

const ArcticAesthetics = () => {
  const [isDarkMode, setIsDarkMode] = useState(() =>
    document.documentElement.classList.contains('dark')
  );

  useEffect(() => {
    setIsDarkMode(document.documentElement.classList.contains('dark'));
  }, []);

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        pointerEvents: 'none',
        zIndex: -1,
      }}
      aria-hidden="true"
    >
      {/* Layer 1: Aurora borealis northern lights */}
      <NorthernLights isDarkMode={isDarkMode} />

      {/* Layer 2: Falling snowflakes */}
      <Snowflakes isDarkMode={isDarkMode} />
    </div>
  );
};

export default ArcticAesthetics;
